import React from 'react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-stone-100" data-id="element-146">
      {/* Background Image Placeholder - In production this would be a real image */}
      <div className="absolute inset-0 z-0" data-id="element-147">
        <img src="https://cdn.magicpatterns.com/uploads/b6uvgnAErYSDrtQu3UNTu5/1.webp" alt="Calentadores vintage de piel sintética con zapatos de plataforma" className="w-full h-full object-cover opacity-90" data-id="element-148" />
        <div className="absolute inset-0 bg-black/20" data-id="element-149" />
      </div>

      <div className="relative z-10 container mx-auto px-4 text-center" data-id="element-150">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-151">
          <span className="inline-block py-1 px-3 border border-white/40 text-white text-xs tracking-[0.2em] uppercase backdrop-blur-sm" data-id="element-152">
            Colección Invierno 2026
          </span>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-white leading-tight drop-shadow-lg" data-id="element-153">
            El detalle que transforma un outfit común en una{' '}
            <span className="italic font-light" data-id="element-154">declaración de estilo</span>.
          </h1>

          <p className="text-xl md:text-2xl text-white/90 font-light max-w-2xl mx-auto leading-relaxed drop-shadow-md" data-id="element-155">
            Calentadores Vintage de Piel Sintética: la textura y el volumen que
            tus botas estaban esperando.
          </p>

          <div className="pt-8" data-id="element-156">
            <Button size="lg" withArrow onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-white text-black hover:bg-stone-100 border-none rounded-full px-10 tracking-widest uppercase text-sm font-semibold shadow-xl hover:shadow-2xl" data-id="element-157">
              Quiero elevar mi estilo hoy
            </Button>
          </div>
        </div>
      </div>
    </section>;
}